import { render, staticRenderFns } from "./list_trivia_component.vue?vue&type=template&id=5c2027d0&scoped=true"
import script from "./list_trivia_component.vue?vue&type=script&lang=js"
export * from "./list_trivia_component.vue?vue&type=script&lang=js"
import style0 from "./list_trivia_component.vue?vue&type=style&index=0&id=5c2027d0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2027d0",
  null
  
)

export default component.exports